// SPDX-FileCopyrightText: 2025 Mercedes-Benz Group AG and Mercedes-Benz AG
//
// SPDX-License-Identifier: Apache-2.0

export const black = '#000000';
export const white = '#ffffff';

export const grey = {
  [95]: '#F8F8F8',
  [90]: '#F4F4F4',
  [85]: '#E8E8E8',
  [80]: '#DBDBDB',
  [75]: '#C9C9C9',
  [70]: '#BBBBBB',
  [65]: '#ADADAD',
  [60]: '#9F9F9F',
  [55]: '#919191',
  [50]: '#848484',
  [45]: '#767676',
  [40]: '#696969',
  [35]: '#5C5C5C',
  [30]: '#4F4F4F',
  [25]: '#424242',
  [20]: '#333333',
  [15]: '#262626',
  [10]: '#1A1A1A',
  [5]: '#0D0D0D',
};

export const blue = {
  [88]: '#2EF0F0',
  [58]: '#1FA3A3',
  [95]: '#E6F5FF',
  [90]: '#CCE8FF',
  [85]: '#B4DDFE',
  [80]: '#9AD2FE',
  [75]: '#80C6FF',
  [70]: '#66BBFD',
  [65]: '#4EAFFD',
  [60]: '#33A4FD',
  [55]: '#1998FC',
  [50]: '#008DFC',
  [45]: '#0078D6',
  [40]: '#036DC1',
  [35]: '#0260AB',
  [30]: '#025497',
  [25]: '#014880',
  [20]: '#013C6B',
  [15]: '#003156',
  [10]: '#002441',
  [5]: '#00182C',
};

export const red = {
  [95]: '#FFEDED',
  [90]: '#FFDBDB',
  [85]: '#FFC9C9',
  [80]: '#FFB7B7',
  [75]: '#FFA5A5',
  [70]: '#FF9292',
  [65]: '#FF8080',
  [60]: '#FF6E6E',
  [55]: '#FF5C5C',
  [50]: '#FF4A4A',
  [45]: '#D92121',
  [40]: '#C31E1E',
  [35]: '#AE1A1A',
  [30]: '#981717',
  [25]: '#821414',
  [20]: '#6D1111',
  [15]: '#570D0D',
  [10]: '#410A0A',
  [5]: '#2B0707',
};

export const green = {
  [95]: '#E9F6EA',
  [90]: '#D3EDD6',
  [85]: '#BCE3C1',
  [80]: '#A6DAAC',
  [75]: '#90D198',
  [70]: '#7AC883',
  [65]: '#64BF6E',
  [60]: '#4DB559',
  [55]: '#37AC45',
  [50]: '#21A330',
  [45]: '#198025',
  [40]: '#177321',
  [35]: '#14661E',
  [30]: '#125A1A',
  [25]: '#0F4D16',
  [20]: '#0D4013',
  [15]: '#0A330F',
  [10]: '#07260B',
  [5]: '#051A07',
};

export const yellow = {
  [95]: '#FFFAE6',
  [90]: '#FEF5CC',
  [85]: '#FEF0B3',
  [80]: '#FDEB99',
  [75]: '#FDE680',
  [70]: '#FCE066',
  [65]: '#FCDB4C',
  [60]: '#FBD633',
  [55]: '#FBD11A',
  [50]: '#FACC00',
  [45]: '#E8BD00',
  [40]: '#D1AA00',
  [35]: '#BA9700',
  [30]: '#A28400',
  [25]: '#8B7100',
  [20]: '#745F00',
  [15]: '#5D4C00',
  [10]: '#463900',
  [5]: '#2E2600',
};

export const orange = {
  [42]: '#B38000',
  [72]: '#F7B100',
  [95]: '#FFF4E6',
  [90]: '#FFE8CC',
  [85]: '#FFDDB3',
  [80]: '#FFD199',
  [75]: '#FFC680',
  [70]: '#FFBA66',
  [65]: '#FFAF4D',
  [60]: '#FFA333',
  [55]: '#FF981A',
  [50]: '#FF6400',
  [45]: '#F04B0A',
  [40]: '#D94000',
  [35]: '#C23800',
  [30]: '#AB3100',
  [25]: '#942900',
  [20]: '#7D2200',
  [15]: '#661A00',
  [10]: '#4F1300',
  [5]: '#380B00',
};

// Additional neutral colors used in themes
export const neutral = {
  [100]: '#ffffff', // pure white
  [99]: '#fcfcfc',
  [98]: '#fafafa',
  [97]: '#f5f5f5',
  [96]: '#f0f0f0',
  [95]: '#e9e9e9',
  [93]: '#e8e8e8',
  [92]: '#e0e0e0',
  [91]: '#d8d8d8',
  [90]: '#d3d3d3',
  [85]: '#BDBDBD',
  [80]: '#bbb',
  [75]: '#A1A1A1',
  [65]: '#808080',
  [60]: '#777777',
  [55]: '#4B4B4B',
  [50]: '#484848',
  [45]: '#464646',
  [40]: '#333',
  [35]: '#2a2a2a',
  [30]: '#212121',
  [25]: '#1f1f1f',
  [20]: '#141414',
  [0]: '#000000', // pure black
};
